import React, { useMemo } from "react";
import MapContainer, { createFitBounds } from "../route-explorer/MapContainer";
import { ATLAS_MAP_HEIGHT_MOBILE } from "../../constants";
import loadable from "@loadable/component";

const LoadableGeoJSONLayer = loadable(async () => {
    const { GeoJSONLayer } = await import(/* webpackChunkName: "ReactMapboxGl" */ "react-mapbox-gl");
    return GeoJSONLayer;
});

const polygonPaint = {
    "fill-color": "#504cf3",
    "fill-opacity": 0.25,
};

function AtlasMap(props) {
    const {
        className,
        geojsonObject,
        viewport,
        onViewportChange,
        markers,
        activeStopId,
        isAutoFollowEnabled,
        setIsAutoFollowEnabled,
        onMarkerClick,
        useTwoColumnLayout,
    } = props;
    const mapHeight = !useTwoColumnLayout ? `${ATLAS_MAP_HEIGHT_MOBILE}px` : `100vh`;
    const fitBounds = useMemo(() => createFitBounds(geojsonObject), [geojsonObject]);
    const activeMarkerIds = useMemo(() => [activeStopId], [activeStopId]);

    return (
        <div className={`trpr-atlas-map ${className}`}>
            <MapContainer
                mapClassName="js__atlas-mapbox-gl"
                markerClasses={`trpr__marker--stop-atlas  ${
                    useTwoColumnLayout ? "trpr__marker--with-two-columns-layout" : ""
                }`}
                fitBounds={fitBounds}
                mainFitBounds={fitBounds}
                viewport={viewport}
                onViewportChange={onViewportChange}
                markers={markers}
                activeMarkerIds={activeMarkerIds}
                isAutoFollowEnabled={isAutoFollowEnabled}
                setIsAutoFollowEnabled={setIsAutoFollowEnabled}
                showAutoFollow={useTwoColumnLayout}
                isDesktop={useTwoColumnLayout}
                mapHeight={mapHeight}
                onMarkerClick={onMarkerClick}
                withMapControls={true}
                useTwoColumnLayout={useTwoColumnLayout}
            >
                <LoadableGeoJSONLayer
                    key={0}
                    data={geojsonObject}
                    fillPaint={polygonPaint}
                    layerOptions={{
                        maxzoom: 11,
                    }}
                />
            </MapContainer>
        </div>
    );
}

export default AtlasMap;
